import React from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { WorkOrderRoutingTableV2 } from "../../tables";
import { AddReworkRouteDialog } from "../../dialogs";
import { getAuthUser } from "../../redux";

export const WorkOrderProduction = ({
  id,
  user = [],
  showCompleted = false,
}) => {
  return (
    <Stack
      padding="15px"
      overflow="auto"
      sx={{
        "*::-webkit-scrollbar": { display: "none !important" },
      }}
    >
      <Stack position="relative" height="100%" overflow="auto">
        <WorkOrderRoutingTableV2
          key={id}
          showCompleted={showCompleted}
          showQuantity
        />
        <AddReworkRouteDialog userId={user?.id} />
      </Stack>
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  user: getAuthUser(state),
});
export const WorkOrderProd = connect(mapStateToProps)(WorkOrderProduction);
export default WorkOrderProd;
